import { UserDroitsProvider } from 'features/utilisateurs/contexts/UtilisateurDroitsProvider';
import { UserInfosProvider } from 'features/utilisateurs/contexts/UtilisateurInfosProvider';
import { UserPerimetreProvider } from 'features/utilisateurs/contexts/UtilisateurPerimetreProvider';
import { UtilisateurFormProvider } from 'features/utilisateurs/contexts/UtilisateurFormProvider';
import React from 'react';
import UsersList from '../../../features/utilisateurs/components/UsersPageList';
import { SGSHelpButton } from 'components';

type Props = {};

const UsersPageList: React.FC<Props> = () => {
    return (
        <>
            <SGSHelpButton />
            <UtilisateurFormProvider>
                <UserInfosProvider>
                    <UserPerimetreProvider>
                        <UserDroitsProvider>
                            <UsersList />
                        </UserDroitsProvider>
                    </UserPerimetreProvider>
                </UserInfosProvider>
            </UtilisateurFormProvider>
        </>
    );
};

export default UsersPageList;
